import React from 'react'

import styles from '../BlogPost.module.scss'

interface StandaloneQuoteProps {
  quote: string
  author: string
}

const StandaloneQuote: React.FC<StandaloneQuoteProps> = ({ quote, author }) => {
  if (!quote?.trim()) return null
  return (
    <blockquote className={styles.standaloneQuote}>
      <div className={styles.standaloneQuoteInner}>
        <p className={styles.standaloneQuoteText}>{quote}</p>
        {author && (
          <>
            <hr className={styles.standaloneQuoteSeparator} aria-hidden />
            <cite className={styles.standaloneQuoteAuthor}>{author}</cite>
          </>
        )}
      </div>
    </blockquote>
  )
}

export default StandaloneQuote
